import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

// Error display component
const VitalsError = ({ error, onRetry }) => (
  <div className="bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-2xl qhd:rounded-3xl p-6 qhd:p-8 4k:p-10 text-center">
    <ExclamationTriangleIcon className="w-12 h-12 qhd:w-14 qhd:h-14 4k:w-16 4k:h-16 text-red-400 mx-auto mb-3 qhd:mb-4" />
    <h3 className="text-lg qhd:text-xl 4k:text-2xl font-semibold text-red-800 dark:text-red-300 mb-2 qhd:mb-3">Failed to Load Vitals</h3>
    <p className="text-red-600 dark:text-red-400 mb-4 qhd:mb-5 4k:mb-6 qhd:text-lg 4k:text-xl">{error}</p>
    <button
      onClick={onRetry}
      className="inline-flex items-center gap-2 qhd:gap-3 px-4 py-2 qhd:px-5 qhd:py-2.5 4k:px-6 4k:py-3 bg-red-600 text-white rounded-lg qhd:rounded-xl hover:bg-red-700 transition-colors qhd:text-base 4k:text-lg"
    >
      <ArrowPathIcon className="w-4 h-4 qhd:w-5 qhd:h-5 4k:w-6 4k:h-6" />
      Try Again
    </button>
  </div>
);

export default VitalsError;
